import { useQuestionnaireDefinition } from "@repo/data-store";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { CatalogDefinition, QuestionnaireEdit } from "@/features/catalog";
import { questionnaireDefinitionUrlFromRouteId } from "@/features/catalog/lib/questionnaire-definition-route";

export const Route = createFileRoute("/catalog/questionnaires/$questionnaireId_/edit")({
  beforeLoad: ({ context }) => {
    if (!context.permissions.canRead("Questionnaire")) {
      throw redirect({ to: "/catalog/questionnaires" });
    }
  },
  component: EditQuestionnaireComponent,
});

function EditQuestionnaireComponent() {
  const { questionnaireId } = Route.useParams();
  const { permissions } = Route.useRouteContext();
  const navigate = useNavigate();
  const questionnaire = useQuestionnaireDefinition(questionnaireDefinitionUrlFromRouteId(questionnaireId));

  if (!questionnaire) {
    return (
      <CatalogDefinition.NotFound
        label="Questionnaire"
        backTo="/catalog/questionnaires"
        backLabel="Back to questionnaires"
      />
    );
  }

  return (
    <QuestionnaireEdit
      key={questionnaireId}
      questionnaire={questionnaire}
      canEdit={permissions.canWrite("Questionnaire")}
      onDone={() => navigate({ to: "/catalog/questionnaires" })}
      onCancel={() => navigate({ to: "/catalog/questionnaires/$questionnaireId", params: { questionnaireId } })}
    />
  );
}
